import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import Footer from "../../Footer";
import swal from "sweetalert";
import ClipLoader from "react-spinners/ClipLoader";

function EditVideoCategory({ match }) {
  const history = useHistory();
  const { token } = isAutheticated();

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // Form States
  const [inputText, setInputText] = useState({
    name: "",
    ownerName: "",
    email: "",
  });

  // Billing States
  const [billing, setBilling] = useState({

    registrationFee: "",
    paymentType: "",
    monthlyFee: "",
    sixMonthFee: "",
    bandwidth: "",
    space: "",
    channelFee: "",

  });

  const [billingChannel, setBillingChannel] = useState({
    Channel_registrationFee: "",
    // channel_paymentType: "monthly",
    channel_monthlyFee: "",
    channel_sixMonthFee: "",
    channel_bandwidth: "",
    channel_space: "",

    // channelFee: "",
  });

  // Image States
  const [thumbnail, setThumbnail] = useState(null);
  const [banner, setBanner] = useState(null);
  const [uploadLogo, setUploadLogo] = useState(null);

  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  // Character Limit
  const wordLimit = { name: 50 };
  const [nameLen, setNameLen] = useState(wordLimit.name);

  // Default placeholders
  const BannerURl =
    "https://res.cloudinary.com/duenuiiav/image/upload/v1738589369/tellytell/content_category/xqznnuqh7g6ozepkorzy.png";
  const ThumbnailURl =
    "https://res.cloudinary.com/duenuiiav/image/upload/v1738589368/tellytell/content_category/tpa6shtnfp9txuekeawo.png";

  // Input Handlers
  const handleInputText = (e) => {
    setInputText({ ...inputText, [e.target.name]: e.target.value });
    if (e.target.name === "name") {
      setNameLen(wordLimit.name - e.target.value.length);
    }
  };

  const handleBillingChange = (e) => {
    setBilling({ ...billing, [e.target.name]: e.target.value });
  };

  const handleBillingChannelChange = (e) => {
    setBillingChannel({ ...billingChannel, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e, setFile, setPreview) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const removeImage = (type) => {
    if (type === "thumbnail") {
      setThumbnail(null);
      setThumbnailPreview(ThumbnailURl);
    } else if (type === "banner") {
      setBanner(null);
      setBannerPreview(BannerURl);
    } else if (type === "logo") {
      setUploadLogo(null);
      setLogoPreview(ThumbnailURl);
    }
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isEmpty = (val) => val === "" || val === null || val === undefined;

  // Fetch Existing Data
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${API}/api/channel/view_by_id_channel/${match.params.id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const channel = res.data?.channel;
        const billingData = res.data?.channel?.billingId || {};
        console.log(channel)
        const billingSub = res.data?.channel?.subChannel_billingId || {};

        setInputText({
          name: channel?.name || "",
          ownerName: channel?.userID?.name || "",
          email: channel?.userID?.email || "",
        });

        setBilling({
          registrationFee: billingData.registrationFee ?? "",
          paymentType: billingData.paymentType || "",

          monthlyFee: billingData.monthlyFee ?? "",
          sixMonthFee: billingData.sixMonthFee ?? "",
          bandwidth: billingData.bandwidth ?? "",
          space: billingData.space ?? "",
        });


        setBillingChannel({
          Channel_registrationFee: billingSub?.Subchannel_registrationFee ?? "",
          channel_monthlyFee: billingSub?.channel_monthlyFee ?? "",
          channel_sixMonthFee: billingSub?.channel_sixMonthFee ?? "",
          channel_bandwidth: billingSub?.channel_bandwidth ?? "",
          channel_space: billingSub?.channel_space ?? "",



          // channel_paymentType: billingSub?.SubchannelpaymentType || "monthly",

          // channelFee: billingSub?.channelFee || "",
        });

        setThumbnailPreview(channel?.thumbnail?.url || ThumbnailURl);
        setBannerPreview(channel?.banner?.url || BannerURl);
        setLogoPreview(channel?.logo?.url || ThumbnailURl);

        setNameLen(wordLimit.name - (channel?.name?.length || 0));
      } catch (error) {
        console.error(error);
        swal("Error", "Failed to fetch channel data", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [match.params.id, token]);

  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!inputText.name) {
      swal("Warning", "Channel Name is mandatory", "warning");
      return;
    }
    if (!inputText.ownerName) {
      swal("Warning", "Network Channel Administrator Name is mandatory", "warning");
      return;
    }

    if (!inputText.email || !isValidEmail(inputText.email)) {
      swal("Warning", "Please enter a valid email", "warning");
      return;
    }
    if (isEmpty(Number(billing.registrationFee))) {
      swal("Warning", "One Time Registration Fee is mandatory.", "warning");
      return;
    }

    if (!billing.paymentType) {
      swal("Warning", "Please select payment type.", "warning");
      return;
    }

    if (billing.paymentType === "monthly" && isEmpty(Number(billing.monthlyFee))) {
      swal("Warning", "Monthly Fee is mandatory.", "warning");
      return;
    }

    if (billing.paymentType === "sixMonths" && isEmpty(Number(billing.sixMonthFee))) {
      swal("Warning", "6-Month Fee is mandatory.", "warning");
      return;
    }

    if (isEmpty(Number(billing.bandwidth))) {
      swal("Warning", "Bandwidth is mandatory.", "warning");
      return;
    }

    if (isEmpty(Number(billing.space))) {
      swal("Warning", "Space is mandatory.", "warning");
      return;
    }

    /* Channel Billing */

    if (isEmpty(billingChannel.Channel_registrationFee)) {
      swal("Warning", "Channel One Time Registration Fee is mandatory.", "warning");
      return;
    }

    if (isEmpty(billingChannel.channel_monthlyFee)) {
      swal("Warning", "Channel Monthly Fee is mandatory.", "warning");
      return;
    }

    if (isEmpty(billingChannel.channel_sixMonthFee)) {
      swal("Warning", "Channel 6-Month Fee is mandatory.", "warning");
      return;
    }

    if (isEmpty(billingChannel.channel_bandwidth)) {
      swal("Warning", "Channel Bandwidth is mandatory.", "warning");
      return;
    }

    if (isEmpty(billingChannel.channel_space)) {
      swal("Warning", "Channel Space is mandatory.", "warning");
      return;
    }

    setSaving(true);

    try {
      const formData = new FormData();
      formData.append("name", inputText.name);
      formData.append("ownerName", inputText.ownerName);
      formData.append("email", inputText.email);
      formData.append("billing", JSON.stringify(billing));
      formData.append("billingSubchannel", JSON.stringify(billingChannel));

      if (thumbnail) formData.append("thumbnail", thumbnail);
      if (banner) formData.append("banner", banner);
      if (uploadLogo) formData.append("logo", uploadLogo);

      const res = await axios.patch(
        `${API}/api/channel/update_channel/${match.params.id}`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res?.data) {
        if (res.data.billingWarnings?.length > 0) {
          swal(
            "Network Channel Updated",
            res.data.billingWarnings.join("\n"),
            "warning"
          ).then(() => history.push("/network_channels"));
        } else {
          swal("Success", "Network Channel updated successfully", "success")
            .then(() => history.push("/network_channels"));
        }
      }

    } catch (error) {
      console.error(error);
      swal(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="text-center p-4 border border-primary rounded shadow">
          <div className="spinner-border text-primary" role="status" />
          <div className="mt-3 fs-5 text-primary">Network Channel Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Page Header */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Edit Network Channel</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">SoComOTT</Link>
                    </li>
                    <li className="breadcrumb-item">Edit Network Channel</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* Main Form */}
          <div className="row">
            {/* Left: Channel Form */}
            <div className="col-lg-7">
              <div className="card">
                <div className="card-body">
                  <h1 className="text-left head-small">Edit Network Channel</h1>
                  <form onSubmit={handleSubmit}>
                    {/* Channel Name */}
                    <div className="form-group">
                      <label>
                        Network Channel Name<span className="text-danger">*</span>
                      </label>
                      <input
                        name="name"
                        type="text"
                        className="form-control input-field"
                        value={inputText.name}
                        onChange={handleInputText}
                      />
                      <small className="text-secondary">
                        Remaining characters: {nameLen}
                      </small>
                    </div>

                    {/* Owner Name */}
                    <div className="form-group">
                      <label>
                        Network Channel Administrator Name<span className="text-danger">*</span>
                      </label>
                      <input
                        name="ownerName"
                        type="text"
                        className="form-control input-field"
                        value={inputText.ownerName}
                        onChange={handleInputText}
                        required
                      />
                    </div>

                    {/* Email */}
                    <div className="form-group">
                      <label>
                        Network Channel Administrator Email<span className="text-danger">*</span>
                      </label>
                      <input
                        name="email"
                        type="email"
                        className="form-control input-field"
                        value={inputText.email}
                        onChange={handleInputText}
                        required
                      />
                    </div>

                    {/* Thumbnail */}
                    <div className="form-group">
                      <label>Thumbnail (320x180 px)</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) =>
                          handleFileChange(e, setThumbnail, setThumbnailPreview)
                        }
                        accept="image/*"
                      />
                      {thumbnailPreview && (
                        <div className="mt-2">
                          <img
                            src={thumbnailPreview}
                            alt="Thumbnail"
                            style={{ maxWidth: "150px", borderRadius: "8px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-danger btn-sm mt-2"
                            onClick={() => removeImage("thumbnail")}
                          >
                            Remove
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Banner */}
                    <div className="form-group">
                      <label>Banner (1260x750 px)</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => handleFileChange(e, setBanner, setBannerPreview)}
                        accept="image/*"
                      />
                      {bannerPreview && (
                        <div className="mt-2">
                          <img
                            src={bannerPreview}
                            alt="Banner"
                            style={{ maxWidth: "400px", borderRadius: "6px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-danger btn-sm mt-2"
                            onClick={() => removeImage("banner")}
                          >
                            Remove
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Logo */}
                    <div className="form-group">
                      <label>Channel Logo (150x60 px)</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) =>
                          handleFileChange(e, setUploadLogo, setLogoPreview)
                        }
                        accept="image/*"
                      />
                      {logoPreview && (
                        <div className="mt-2">
                          <img
                            src={logoPreview}
                            alt="Logo"
                            style={{ maxWidth: "150px", borderRadius: "8px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-danger btn-sm mt-2"
                            onClick={() => removeImage("logo")}
                          >
                            Remove
                          </button>
                        </div>
                      )}
                    </div>

                    {/* <button type="submit" className="btn btn-primary" disabled={saving}>
                      {saving ? <ClipLoader size={18} /> : "Save Changes"}
                    </button> */}
                    <button type="submit" disabled={saving} className="btn btn-primary w-100 mt-3">
                      {saving ? <ClipLoader size={22} color="#fff" /> : "Save Changes"}
                    </button>
                  </form>
                </div>
              </div>
            </div>

            {/* Right: Billing Section */}
            <div className="col-lg-5">
              <div className="card">
                <div className="card-body">
                  <h4 className="mb-3 text-center head-small">Billing - Network Channel</h4>
                  <form>
                    {/* Registration Fee */}
                    <div
                      className="p-3 mb-3 rounded"
                      style={{ backgroundColor: "#fdebd0" }}
                    >
                      <div className="row mb-3">
                        <label className="col-sm-6 col-form-label">
                          One Time Registration Fee
                        </label>
                        <div className="col-sm-6">
                          <div className="input-group">
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="registrationFee"
                              value={billing.registrationFee}
                              onChange={handleBillingChange}
                              min="0"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Subscription Fee Options (Network Channel) */}
                    <div
                      className="p-3 mb-3 rounded"
                      style={{ backgroundColor: "#d6eaf8" }}
                    >
                      <h5 className="mb-3 ">Subscription Fee</h5>

                      {/* Monthly option - single horizontal row */}
                      {/* <div className="row align-items-center mb-2">
                        <div className="col-sm-6 d-flex align-items-center">
                          <div className="form-check me-2">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="paymentType"
                              value="monthly"
                              checked={billing.paymentType === "monthly"}
                              onChange={handleBillingChange}
                            />
                          </div>
                          <label className="mb-0">Pay Monthly</label>
                        </div>

                        <div className="col-sm-6">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="monthlyFee"
                              value={billing.monthlyFee}
                              onChange={handleBillingChange}
                              min="0"
                              disabled={billing.paymentType !== "monthly"}
                            />
                          </div>
                        </div>
                      </div> */}
                      <div className="row align-items-center mb-2">
                        <div className="col-sm-6">
                          <input
                            className="form-check-input ms-1"
                            type="radio"
                            name="paymentType"
                            value="monthly"
                            checked={billing.paymentType === "monthly"}
                            onChange={handleBillingChange}
                          />
                          <label className="mb-0 ms-4">
                            Pay Monthly <span className="text-danger">*</span>
                          </label>                        </div>
                        <div className="col-sm-6">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="monthlyFee"
                              value={Number(billing.monthlyFee)}
                              onChange={handleBillingChange}
                              min="0"
                              required
                              disabled={billing.paymentType !== "monthly"}

                            />
                          </div>
                        </div>
                      </div>

                      {/* 6-Month option - single horizontal row */}
                      <div className="row align-items-center mb-3">
                        <div className="col-sm-6">
                          <input
                            className="form-check-input ms-1"
                            type="radio"
                            name="paymentType"
                            value="sixMonths"
                            checked={billing.paymentType === "sixMonths"}
                            onChange={handleBillingChange}
                          />





                          <label className="mb-0 ms-4">
                            Pay for 6 Months <span className="text-danger">*</span>
                          </label>                        </div>
                        <div className="col-sm-6">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="sixMonthFee"
                              value={billing.sixMonthFee}
                              onChange={handleBillingChange}
                              min="0"
                              required
                              disabled={billing.paymentType !== "sixMonths"}

                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="row align-items-center mb-3">
                        <div className="col-sm-6 d-flex align-items-center">
                          <div className="form-check me-2">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="paymentType"
                              value="sixMonths"
                              checked={billing.paymentType === "sixMonths"}
                              onChange={handleBillingChange}
                            />
                          </div>
                          <label className="mb-0">Pay for 6 Months</label>
                        </div>

                        <div className="col-sm-6">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="sixMonthFee"
                              value={billing.sixMonthFee}
                              onChange={handleBillingChange}
                              min="0"
                              disabled={billing.paymentType !== "sixMonths"}
                            />
                          </div>
                        </div>
                      </div> */}

                      {/* Bandwidth */}
                      <div className="row mb-3">
                        <label className="col-sm-6 col-form-label">
                          Bandwidth<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-6">
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              name="bandwidth"
                              value={billing.bandwidth}
                              onChange={handleBillingChange}
                              min="0"
                              required
                            />
                            <span className="input-group-text">GB</span>
                          </div>
                        </div>
                      </div>

                      {/* Space */}
                      <div className="row mb-3">
                        <label className="col-sm-6 col-form-label">
                          Space<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-6">
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              name="space"
                              value={billing.space}
                              onChange={handleBillingChange}
                              min="0"
                              required
                            />
                            <span className="input-group-text">GB</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <hr />
                  {/* Billing-Channel Section */}
                  <h4 className="mb-3 text-center head-small">Billing - Channel</h4>
                  <form>
                    <div
                      className="p-3 mb-3 rounded"
                      style={{ backgroundColor: "#fdebd0" }}
                    >
                      <div className="row mb-3 ">
                        <label className="col-sm-6 col-form-label">
                          One Time Registration Fee
                        </label>
                        <div className="col-sm-6">
                          <div className="input-group">
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="Channel_registrationFee"
                              value={billingChannel.Channel_registrationFee}
                              onChange={handleBillingChannelChange}
                              min="0"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="p-3 mb-3 rounded"
                      style={{ backgroundColor: "#d6eaf8" }}
                    >
                      <h5 className="mb-3 ">Channel Subscription Fee</h5>

                      {/* Channel Monthly option row */}
                      {/* <div className="row align-items-center mb-2">
                        <div className="col-sm-6 d-flex align-items-center">
                          <div className="form-check me-2">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="channel_paymentType"
                              value="monthly"
                              checked={billingChannel.channel_paymentType === "monthly"}
                              onChange={() =>
                                setBillingChannel({ ...billingChannel, channel_paymentType: "monthly" })
                              }
                            />
                          </div>
                          <label className="mb-0">Pay Monthly</label>
                        </div>

                        <div className="col-sm-6">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="channel_monthlyFee"
                              value={billingChannel.channel_monthlyFee}
                              onChange={handleBillingChannelChange}
                              min="0"
                              disabled={billingChannel.channel_paymentType !== "monthly"}
                              required={billingChannel.channel_paymentType === "monthly"}
                            />
                          </div>
                        </div>
                      </div> */}
                      <div className="row align-items-center mb-2">
                        <div className="col-sm-6">
                          <label className="mb-0">Pay Monthly<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-sm-6">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="channel_monthlyFee"
                              value={billingChannel.channel_monthlyFee}
                              onChange={handleBillingChannelChange}
                              min="0"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      {/* Channel 6-month option row */}
                      {/* <div className="row align-items-center mb-3">
                        <div className="col-sm-6 d-flex align-items-center">
                          <div className="form-check me-2">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="channel_paymentType"
                              value="sixMonths"
                              checked={billingChannel.channel_paymentType === "sixMonths"}
                              onChange={() =>
                                setBillingChannel({ ...billingChannel, channel_paymentType: "sixMonths" })
                              }
                            />
                          </div>
                          <label className="mb-0">Pay for 6 Months</label>
                        </div>

                        <div className="col-sm-6">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="channel_sixMonthFee"
                              value={billingChannel.channel_sixMonthFee}
                              onChange={handleBillingChannelChange}
                              min="0"
                              disabled={billingChannel.channel_paymentType !== "sixMonths"}
                              required={billingChannel.channel_paymentType === "sixMonths"}
                            />
                          </div>
                        </div>
                      </div> */}
                      <div className="row align-items-center mb-3">
                        <div className="col-sm-6">
                          <label className="mb-0">Pay for 6 Months<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-sm-6">
                          <div className="input-group" style={{ maxWidth: 260 }}>
                            <span className="input-group-text">$</span>
                            <input
                              type="number"
                              className="form-control"
                              name="channel_sixMonthFee"
                              value={billingChannel.channel_sixMonthFee}
                              onChange={handleBillingChannelChange}
                              min="0"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      {/* Bandwidth */}
                      <div className="row mb-3">
                        <label className="col-sm-6 col-form-label">
                          Channel Bandwidth<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-6">
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              name="channel_bandwidth"
                              value={billingChannel.channel_bandwidth}
                              onChange={handleBillingChannelChange}
                              min="0"
                              required
                            />
                            <span className="input-group-text">GB</span>
                          </div>
                        </div>
                      </div>

                      {/* Space */}
                      <div className="row mb-3">
                        <label className="col-sm-6 col-form-label">
                          Channel Space<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-6">
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              name="channel_space"
                              value={billingChannel.channel_space}
                              onChange={handleBillingChannelChange}
                              min="0"
                              required
                            />
                            <span className="input-group-text">GB</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* End Billing Section */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EditVideoCategory;
